(() => {
  function revealHero(hero) {
    if (hero.dataset.gsInitialized === 'true') return;

    hero.dataset.gsInitialized = 'true';
    hero.classList.add('gs-pending');

    if (!('IntersectionObserver' in window)) {
      hero.classList.add('gs-is-visible');
      return;
    }

    const observer = new IntersectionObserver((entries, observerInstance) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        entry.target.classList.add('gs-is-visible');
        observerInstance.unobserve(entry.target);
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -20px 0px'
    });

    observer.observe(hero);
  }

  function initializeHeroes(scope = document) {
    if (scope.matches?.('.gs-dumbbell-hero')) {
      revealHero(scope);
    }

    scope.querySelectorAll?.('.gs-dumbbell-hero').forEach(revealHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeHeroes(), { once: true });
  } else {
    initializeHeroes();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeHeroes(event.target);
  });
})();
